module.exports = __webpack_public_path__ + "img/pic_xyzp_pc.cd4e023a.jpg";